import { Tile } from '@carbon/react';
import { EmptyState } from 'components/empty-state';
import {
  itemRangeText,
  pageRangeText,
} from 'components/search/common/format-helpers';
import { SearchResult, WellsResponse } from 'types/api-responses';
import { SearchParams } from 'atoms/search-atom';
import { Pagination } from 'components/pagination';
import { WellCard } from './well-card';
import { WellFacets } from './types';
import { DocumentSearchSkeleton } from '../documents-search/documents-search-skeleton.module';

const PAGE_SIZES = [10, 30];

interface Props {
  searchResult?: SearchResult<WellsResponse, WellFacets>;
  onChange: (payload: SearchParams) => void;
  loading?: boolean;
}

export function Wells({ loading, searchResult, onChange }: Props) {
  const handlePageChange = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    window.scrollTo(0, 0);
    onChange({ page, pageSize });
  };

  return loading ? (
    <DocumentSearchSkeleton elementCount={10} />
  ) : searchResult ? (
    <div style={{ position: 'relative' }}>
      {searchResult.results.length ? (
        <>
          {searchResult.results.map((result) => (
            <WellCard key={result.id} well={result} />
          ))}
          <Pagination
            pageSizes={PAGE_SIZES}
            pageSize={searchResult.pageSize}
            page={searchResult.page}
            totalItems={searchResult.totalCount}
            onChange={handlePageChange}
            itemRangeText={itemRangeText}
            pageRangeText={pageRangeText}
          />
        </>
      ) : (
        <Tile>
          <EmptyState
            headerText="No Results Found"
            helperText="Try adjusting your search options to find what you’re looking for."
          />
        </Tile>
      )}
    </div>
  ) : null;
}
